import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { commonImages } from '@images/common-images';
import { DashService } from '@modules/dash-board/dash.service';
import { ApiService } from '@services/api/api.service';
import { LeadsService } from '@services/api/leads.service';
import { ProjectService } from '@services/api/project.service';
import { UserService } from '@services/api/user.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ReduxService } from '@state-management/redux.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-edit-eoi',
  templateUrl: './edit-eoi.component.html',
  styleUrls: ['./edit-eoi.component.scss'],
})
export class EditEoiComponent implements OnDestroy {
  @Input() eoiTabIndex: any;
  @Input() editDetail: any = {};
  @Input() isCreateNew: boolean = false;
  @Input() selected_unit_id: any = null;
  @Input() isFileShow: boolean = false;
  @Output() isEOIClosed = new EventEmitter<any>();

  private destroy$ = new Subject<void>();

  Utils = Utils; // 👈 expose Utils class to the template
  isEOIEdit: boolean = false;
  common_images = commonImages;

  EOI_form: FormGroup;
  price_term: boolean = false;
  upgrades: any[] = [
    {
      upgrade_group_1: null,
      upgrade_group_1_price: null,
      upgrades_total: null,
    },
  ];
  bonuses: any[] = [
    {
      campaign: null,
      bonus: null,
      payableUpon: null,
      payableTo: null,
    },
  ];

  YpmSales: any[] = [];
  association_internal_agent: any[] = [];
  internal_agent: any[] = [];
  internal_team: any[] = [];
  externalAgency: any[] = [];
  associate_user: any;

  firb = [
    { name: 'No', val: 'No' },
    { name: 'Yes', val: 'Yes' },
  ];
  purchase_type = [];

  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));
  public userPermission = Crypto.decrypt(this.localStorageService.GetItem('_per'));

  showMenu = false;
  selectedItem = null;
  tabIndexValue: number = 0;

  menu_items = [
    { index: 0, name: 'Critical Date' },
    { index: 1, name: 'Purchaser Details' },
    { index: 2, name: 'Sale Details' },
    { index: 3, name: 'Solicitor Details' },
    { index: 4, name: 'Agency Details' },
    { index: 5, name: 'Files' },
    { index: 6, name: 'Notes' },
  ];
  agencyList: any = [];
  mentionConfig: any | null = null; // start as null

  constructor(
    private Api: ApiService,
    private toast: ToastrService,
    public lmService: LeadManagementService,
    private localStorageService: LocalStorageService,
    private fb: FormBuilder,
    private router: Router,
    private _userService: UserService,
    private _projectService: ProjectService,
    private dash: DashService,
    private redux: ReduxService,
    private leadsService: LeadsService
  ) {
    this.EOI_form = this.fb.group({
      // top Details
      projectid: null,
      status_reason: null,
      ypm_sale: null,
      unit_id: null,
      sale_type: null,
      // Critical Dates
      date_received: null,
      contract_date: null,
      contract_issued_date: null,
      cool_off_expiry_date: null,
      contract_due_date: null,
      bal_deposit_due_date: null,
      contract_received_date: null,
      finance_due_date: null,
      firb_due_date: null,
      additional_condition: null,
      admin_only_comments: null,
      admin_comments_user: null,
      comments_user: null,
      comments: null,
      agent_comments: null,
      agent_comments_user: null,
      unconditional_date: null,
      projected_settlement_date: null,
      settlement_date: null,
      cancelled_date: null,
      cancelled_reason: null,
      balance_deposit_paid: false,
      cancelled: false,
      finance_approved: false,
      firb_approved: false,
      additional_condition_satisfied: false,
      // Purchaser Detail
      purchaser_1: null,
      client_first_name: null,
      purchaser_2: null,
      purchaser_3: null,
      nationality_purchaser_1: null,
      nationality_purchaser_2: null,
      nationality_purchaser_3: null,
      firb: null,
      purchase_type: null,
      // Sale Detail
      contract_price: 0,
      initial_deposit: 0,
      deductible_incentives: null,
      balance_of_deposit: 0,
      deductible_incentives_price: 0,
      total_deposit: 0,
      deposit_comments: null,

      carpark_included: null,
      carpark_added: null,
      carpark_price: 0,
      storage_included: null,
      storage_added: null,
      storage_price: 0,
      subtotal: 0,
      upgrade_group_1: null,
      upgrade_group_1_price: null,
      upgrades_total: 0,
      bonus: 0,
      bonus_payable_upon: null,
      bonus_payable_to: null,
      bonus_campaign: null,
      bonus_comments: null,
      total_price: 0,
      // Solicitor Detail
      firm: null,
      solicitor_name: null,
      // Agency Detail
      agency: null,
      agent: null,
      internal_team: null,
      internal_agent: null,
      internal_agent_2: null,
      internal_agent_3: null,
      reservation_code: null,
      sales_related_notes: null,
      commission_comments: null,
      other_upgrade_group: null,
      other_upgrade_type: null,
      other_upgrade_price: null,

      // bonus
    });
  }

  isMobile_device = false;
  selected_EOI = null;
  eoiLeadId = null;
  eoi_status_folder: string = null;
  eoi_folder: string = null;
  selected_eoi = null;

  /** EOI records carry the project under either name depending on origin — used to scope the External EOI Link panel below. */
  get externalEoiProjectId(): string | null {
    return this.selected_eoi?.project_id || this.selected_eoi?.projectid || null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selected_eoi = changes?.editDetail?.currentValue;
    let id = this.selected_eoi?.project_id ? this.selected_eoi?.project_id : this.selected_eoi?.projectid;
    this.lmService.getUnit(id, true);
    this.lmService.GetProjectDetail(id);
    this.getCarParkStorage(id);
    setTimeout(() => {
      this.getAssociate(true, id);
    }, 500);
  }

  ngOnInit(): void {
    // Get the project list
    this.lmService.GetProjectList();
    this.getAgencyList();
    // Get the tags list
    this.getTags();

    this.lmService.agencyListUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getAgencyList();
    });

    // Subscribe to the screen size observable
    this.dash?.screenSize$?.subscribe(size => {
      // If the screen size is less than 768px, set the isMobile_device flag to true
      if (size.width < 768) {
        this.isMobile_device = true;
      } else {
        // Otherwise, set the isMobile_device flag to false
        this.isMobile_device = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAgencyList() {
    let office_id = this.Api.getOfficeId();
    let user_id = this.Api.getUserId();
    let url = `/contacts/list?office_id=${office_id}&uid=${user_id}&type=All&page=1&per_page=990&user_type=Contact&company_type=${JSON.stringify(['Agency', 'Solicitor'])}`;
    this.Api.get(url).subscribe({
      next: (response: any) => {
        this.agencyList = response?.data?.sort((a, b) => a?.full_name.localeCompare(b?.full_name));
        // The record may have set the Firm before this list arrived — see loadSolicitorContacts().
        this.loadSolicitorContacts();
      },
    });
  }

  selectItem(item: any) {
    // Set the selected item name and tab index
    // Hide the menu after selection
    this.selectedItem = item?.name;
    this.tabIndexValue = item?.index;
    this.showMenu = false;
  }

  editContact(record, param = null) {
    if (param) {
      if (param == 'purchaser_1') {
        this.lmService.isEdit_show_div = 'edit_contact';
        let name = record?.purchaser_1_name || '';
        record['_id'] = record?.purchaser_1;
        this.lmService.addTabInLevels(`Contact-${name}`, record?.purchaser_1, record, null, 'contact');
        this.lmService.cont_id = record?.purchaser_1;
      }
      if (param == 'purchaser_2') {
        this.lmService.isEdit_show_div = 'edit_contact';
        let name = record?.purchaser_2_name || '';
        record['_id'] = record?.purchaser_2;
        this.lmService.addTabInLevels(`Contact-${name}`, record?.purchaser_2, record, null, 'contact');
        this.lmService.cont_id = record?.purchaser_2;
      }
    } else {
      this.lmService.isEdit_show_div = 'edit_contact';
      let name = record?.name ? record?.name : record?.full_name || '';
      this.lmService.addTabInLevels(`Contact-${name}`, record?._id, record, null, 'contact');
      this.lmService.cont_id = record?._id;
    }
  }

  editRecord(lead) {
    this.lmService.backToEOIList = true;
    this.router.navigate(['/leads'], { queryParams: { id: lead?._id } });
  }

  allowEdit() {
    let project_association = this.lmService.ProjectDetail?.projectassociation_settings[0];
    let user_id = this.Api.getUserId();

    // High priority roles
    let isAdminRole = this.userRole === 'master admin' || this.userRole === 'operations manager';

    // Admin users
    let isAdminUser = project_association?.admins_users?.includes(user_id) || project_association?.salesmanagers_users?.includes(user_id);

    let isAdminTeamUser =
      project_association?.salesmanagers_teams_users?.includes(user_id) || project_association?.admins_teams_users?.includes(user_id);

    // Agent / internal users
    let isAgent =
      project_association?.internals_users?.includes(user_id) ||
      project_association?.internals_teams_users?.includes(user_id) ||
      this.userRole === 'sales agent';

    if (isAdminRole || isAdminUser || isAdminTeamUser) return true;

    if (isAgent) return false;

    return false;
  }

  isAgentAllow() {
    let project_association = this.lmService.ProjectDetail?.projectassociation_settings[0];
    let user_id = this.Api.getUserId();

    // High priority roles
    let isAdminRole = this.userRole === 'master admin' || this.userRole === 'operations manager';

    // Admin users
    let isAdminUser = project_association?.admins_users?.includes(user_id) || project_association?.salesmanagers_users?.includes(user_id);

    let isAdminTeamUser =
      project_association?.salesmanagers_teams_users?.includes(user_id) || project_association?.admins_teams_users?.includes(user_id);

    // Agent / internal users
    let isAgent =
      project_association?.internals_users?.includes(user_id) ||
      project_association?.internals_teams_users?.includes(user_id) ||
      this.userRole === 'sales agent';

    if (isAdminRole || isAdminUser || isAdminTeamUser) return false;

    if (isAgent) return true;

    return false;
  }

  changeEOIStatus() {
    let project_association = this.lmService.ProjectDetail?.projectassociation_settings[0];
    let user_id = this.Api.getUserId();
    let isAdmin = this.userRole == 'master admin' || this.userRole == 'operations manager';
    let isAdminUser = project_association['admins_users']?.includes(user_id) || project_association['salesmanagers_users']?.includes(user_id);
    let isAdminTeamUser =
      project_association['salesmanagers_teams_users']?.includes(user_id) || project_association['admins_teams_users']?.includes(user_id);

    let isAgent =
      project_association['internals_users']?.includes(user_id) ||
      project_association['internals_teams_users']?.includes(user_id) ||
      this.userRole == 'sales agent';

    if (isAdminUser || isAdminTeamUser || isAdmin) {
      return;
    }

    if (isAgent) {
      this.toast.error("Agent can't cancel the EOI");
      this.EOI_form.patchValue({
        status_reason: this.selected_EOI?.status_reason,
      });
    }
  }

  dialog_title = null;
  openModal(item, value) {
    /**
     * Open a modal with the specified item and value
     * @param item the item to be opened in the modal
     * @param value the value of the item to be opened in the modal
     */
    if (value == 'project') {
      // Close the EOI form
      this.closeEOI();
      // Hide the right sidebar
      this.lmService.showRightBar = false;
      // Clear the tab levels
      this.lmService.tab_levels = [];
      // Navigate to the project edit page
      // this.router.navigate(['/project/projects']);
      setTimeout(() => {
        this.router.navigate([`/projects/edit_/${item?._id}/price-list`]);
      }, 1000);
    } else if (value === 'contact') {
      // Get the full name of the contact
      let name = item?.full_name !== ' ' ? item?.full_name : item?.company_name;
      // Show the edit contact div
      this.lmService.isEdit_show_div = 'edit_contact';
      // Add the contact to the tab levels
      this.lmService.addTabInLevels(`Contact-${name}`, item?._id, item, null, 'contact');
      // Set the contact id
      this.lmService.cont_id = item?._id;
    } else if (value == 'internal') {
      // Add the staff to the tab levels
      this.lmService.addTabInLevels(`Staff-${item?.name}`, item?._id, null, null, 'staff');
    } else {
      // Add the lot to the tab levels
      this.lmService.addTabInLevels(`Lot - ${item?.lot_name}`, item?._id, item, null, 'lot');
    }
  }
  clear(_item, method) {
    /**
     * Clear the selected item from the specified control in the EOI form
     * @param item the item to be cleared
     * @param method the name of the control to be cleared
     */
    const controlMap = {
      project: 'projectid',
      unit: 'unit_id',
      contact1: 'purchaser_1',
      contact2: 'purchaser_2',
      agent: 'agent',
      agency: 'agency',
      agen1: 'internal_agent',
      agent2: 'internal_agent_2',
      agen3: 'internal_agent_3',
    };

    /**
     * Clear the selected item from the specified control in the EOI form
     */
    const controlName = controlMap[method] || method;
    if (this.EOI_form.controls[controlName]) {
      this.EOI_form.controls[controlName].setValue(null);
    }
  }

  externalAgencyLoaded: boolean = false;
  agencyContactLoaded: boolean = false;
  internalAgentsLoaded: boolean = false;

  /**
   * ng-select shows an empty chip when the control holds an id that has no
   * matching record in its option list (removed contact, or a blank value
   * returned by the API). Reset the control so the placeholder shows instead.
   * @param controlName the control to verify
   * @param list the option list the control is bound to
   * @param listLoaded whether that option list has been fetched yet
   * @param key the property the option list is keyed by
   */
  private resolveSelection(controlName: string, list: any[], listLoaded: boolean, key: string = '_id') {
    const control = this.EOI_form?.controls[controlName];
    const value = control?.value;
    if (!control || value === null || value === undefined) {
      return;
    }
    if (value === '' || (listLoaded && !list?.some(item => item?.[key] === value))) {
      control.setValue(null, { emitEvent: false });
    }
  }

  /**
   * Drop any agency / agent selection that no longer resolves to a record.
   * Each list is only checked once it has actually been fetched, so a value is
   * never cleared while its options are still loading.
   */
  syncAgencySelections() {
    this.resolveSelection('agency', this.externalAgency, this.externalAgencyLoaded);
    this.resolveSelection('agent', this.agency_contact, this.agencyContactLoaded);
    this.resolveSelection('internal_team', this.internal_team, this.internalAgentsLoaded);
    this.resolveSelection('internal_agent', this.internal_agent, this.internalAgentsLoaded);
    this.resolveSelection('internal_agent_2', this.internal_agent, this.internalAgentsLoaded);
    this.resolveSelection('internal_agent_3', this.internal_agent, this.internalAgentsLoaded);
  }

  patchEditForm(id, includeLookups = false) {
    /**
     * Patch the EOI form with the selected EOI data
     * @param id the ID of the EOI to be patched
     */
    if (id) {
      this._projectService.getExpressionOfInterestById(id, includeLookups).subscribe(res => {
        // Set the selected EOI

        this.upgrades = res?.data?.upgrades ? res?.data?.upgrades : this.upgrades;
        this.bonuses = res?.data?.bonuses ? res?.data?.bonuses : [];
        res?.data?.upgrades
          ? this.upgrades.forEach((item, i) => {
              this.upgradeGroupList[i] = item?.upgrade_group_1_price?.list;
            })
          : null;

        if (res?.data?.carpark_info?.length > 0) {
          let car_park_included = res?.data?.carpark_info.filter(ele => ele?.included == 'Yes' && !ele?.car_park_no).map(item => item.carpark_lot);
          let car_park_added = res?.data?.carpark_info.filter(ele => ele?.included == 'No' && !ele?.car_park_no).map(item => item.carpark_lot);
          res['data'] = {
            ...res?.data,
            carpark_included: car_park_included,
            carpark_added: car_park_added,
          };
        }

        if (res?.data?.storage_info?.length > 0) {
          let storage_included = res?.data?.storage_info.filter(ele => ele?.included == 'Yes').map(item => item.storage_no);
          let storage_add = res?.data?.storage_info.filter(ele => ele?.included == 'No').map(item => item.storage_no);
          res['data'] = {
            ...res?.data,
            storage_included: storage_included,
            storage_added: storage_add,
          };
        }

        // !res?.data?.carpark_info?.length && (res['data'].carpark_price = 0);
        // !res?.data?.storage_info?.length && (res['data'].storage_price = 0);

        this.selected_EOI = res?.data;
        this.eoiLeadId = res?.data?._id;
        this.eoi_status_folder = this.selected_EOI['status_reason']?.toString()?.toLowerCase();
        this.eoi_folder = `${this.selected_EOI['unit_name']} (${this.selected_EOI['client_first_name']})`;
        console.log('selected_EOI >> ', this.selected_EOI);
        if (res?.data?.other_upgrade) {
          this.isOtherUpgrade = true;
          this.otherUpgrade = res?.data?.other_upgrade;
        }
        // Patch the EOI form with the selected EOI data
        this.EOI_form.patchValue(res?.data);
        // Patch the date fields in the EOI form
        this.EOI_form.patchValue({
          bal_deposit_due_date: res?.data?.bal_deposit_due_date ? new Date(res?.data?.bal_deposit_due_date) : null,
          contract_date: res?.data?.contract_date ? new Date(res?.data?.contract_date) : null,
          contract_due_date: res?.data?.contract_due_date ? new Date(res?.data?.contract_due_date) : null,
          contract_issued_date: res?.data?.contract_issued_date ? new Date(res?.data?.contract_issued_date) : null,
          contract_received_date: res?.data?.contract_received_date ? new Date(res?.data?.contract_received_date) : null,
          cool_off_expiry_date: res?.data?.cool_off_expiry_date ? new Date(res?.data?.cool_off_expiry_date) : null,
          date_received: res?.data?.date_received ? new Date(res?.data?.date_received) : null,
          finance_due_date: res?.data?.finance_due_date ? new Date(res?.data?.finance_due_date) : null,
          firb_due_date: res?.data?.firb_due_date ? new Date(res?.data?.firb_due_date) : null,
          projected_settlement_date: res?.data?.projected_settlement_date ? new Date(res?.data?.projected_settlement_date) : null,
          settlement_date: res?.data?.settlement_date ? new Date(res?.data?.settlement_date) : null,
          unconditional_date: res?.data?.unconditional_date ? new Date(res?.data?.unconditional_date) : null,
          cancelled_date: res?.data?.cancelled_date ? new Date(res?.data?.cancelled_date) : null,
        });
        // Set the purchaser list
        this.purchaser_list = res?.data?.purchaser_list?.length > 0 ? res?.data?.purchaser_list : [];
        // Drop blank / unresolved agency selections coming from the record
        this.syncAgencySelections();
        // Call the solicitor contact API
        this.solicitorContact();
        this.getTeamUser(true);
      });
    } else {
      if (this.isCreateNew) {
        this.EOI_form.patchValue({
          projectid: this.selected_eoi?.project_id,
          date_received: new Date(),
          status_reason: 'Held',
        });
      }
    }
  }

  purchaser_list: any[] = [];
  addPurchaser() {
    /**
     * Add a new purchaser to the list
     */
    this.purchaser_list.push({ purchaser: null, nationality: null });
  }

  removePurchaser(i) {
    /**
     * Remove a purchaser from the list
     * @param i the index of the purchaser to be removed
     */
    this.purchaser_list.splice(i, 1);
  }

  selectDate(controller) {
    /**
     * Patch the date formate with the EOI date field
     * @param controller the controller of the EOI to be patched
     */
    if (controller == 'date_received') {
      let date_value = this.EOI_form.controls['date_received'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        date_received: new Date(val),
      });
    } else if (controller == 'contract_issued_date') {
      let date_value = this.EOI_form.controls['contract_issued_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        contract_issued_date: new Date(val),
      });
    } else if (controller == 'contract_due_date') {
      let date_value = this.EOI_form.controls['contract_due_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        contract_due_date: new Date(val),
      });
    } else if (controller == 'contract_received_date') {
      let date_value = this.EOI_form.controls['contract_received_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        contract_received_date: new Date(val),
      });
    } else if (controller == 'contract_date') {
      let date_value = this.EOI_form.controls['contract_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        contract_date: new Date(val),
      });
    } else if (controller == 'cool_off_expiry_date') {
      let date_value = this.EOI_form.controls['cool_off_expiry_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        cool_off_expiry_date: new Date(val),
      });
    } else if (controller == 'bal_deposit_due_date') {
      let date_value = this.EOI_form.controls['bal_deposit_due_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        bal_deposit_due_date: new Date(val),
      });
    } else if (controller == 'finance_due_date') {
      let date_value = this.EOI_form.controls['finance_due_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        finance_due_date: new Date(val),
      });
    } else if (controller == 'firb_due_date') {
      let date_value = this.EOI_form.controls['firb_due_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        firb_due_date: new Date(val),
      });
    } else if (controller == 'unconditional_date') {
      let date_value = this.EOI_form.controls['unconditional_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        unconditional_date: new Date(val),
      });
    } else if (controller == 'projected_settlement_date') {
      let date_value = this.EOI_form.controls['projected_settlement_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        projected_settlement_date: new Date(val),
      });
    } else if (controller == 'settlement_date') {
      let date_value = this.EOI_form.controls['settlement_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        settlement_date: new Date(val),
      });
    } else if (controller == 'cancelled_date') {
      let date_value = this.EOI_form.controls['cancelled_date'].value;
      let val = Utils.getDateStringFormat(date_value);
      this.EOI_form.patchValue({
        cancelled_date: new Date(val),
      });
    }
  }

  onUpdateMSelect = (eve: any, type: string) => {
    if (type == 'purchaser_1') {
      this.EOI_form.patchValue({
        [type]: eve?._id ? eve?._id : null,
        client_first_name: eve?.name ? eve?.name : null,
      });
    } else {
      this.EOI_form.patchValue({
        [type]: eve?._id ? eve?._id : null,
      });
    }
  };

  onUpdateOtherPurchaser = (eve: any, index: number = 0) => {
    this.purchaser_list[index].purchaser = eve || null;
    // this.purchaser_list[index].purchaser = eve?._id ? eve?._id : null;
  };

  updatePrice(value, param: string, index = 0) {
    if (param == 'contract_price') {
      this.EOI_form.patchValue({
        contract_price: value,
        subtotal: this.selected_EOI?.subtotal ? this.selected_EOI?.subtotal : value,
        total_price: this.selected_EOI?.total_price ? this.selected_EOI?.total_price : value,
      });
    } else if (param == 'total_deposit') {
      this.EOI_form.patchValue({
        total_deposit: value,
        balance_of_deposit: value - this.EOI_form.controls['initial_deposit'].value,
      });
    } else if (param == 'initial_deposit') {
      this.EOI_form.patchValue({
        initial_deposit: value,
        balance_of_deposit: this.EOI_form.controls['total_deposit'].value - value,
      });
    } else if (param == 'balance_of_deposit') {
      this.EOI_form.patchValue({
        balance_of_deposit: value,
      });
    } else if (param == 'carpark_price') {
      this.EOI_form.patchValue({
        carpark_price: value,
      });
    } else if (param == 'storage_price') {
      this.EOI_form.patchValue({
        storage_price: value,
      });
    } else if (param == 'deductible_incentives_price') {
      this.EOI_form.patchValue({
        deductible_incentives_price: value,
        subtotal: this.EOI_form.controls['contract_price'].value - value,
      });
    } else if (param == 'subtotal') {
      this.EOI_form.patchValue({
        subtotal: value,
      });
    } else if (param == 'total_price') {
      this.EOI_form.patchValue({
        total_price: value,
      });
    } else if (param == 'subtotal') {
      this.EOI_form.patchValue({
        subtotal: value,
      });
    } else if (param == 'bonus_form') {
      this.EOI_form.patchValue({
        bonus: value,
      });
    } else if (param == 'upgrades_total') {
      this.upgrades[index].upgrades_total = value;
    } else if (param == 'bonus') {
      this.bonuses[index].bonus = value;
    } else if (param == 'other_upgrade_price') {
      if (value) {
        let contract_price = this.EOI_form.controls['contract_price'].value;
        let storage_price = this.EOI_form.controls['storage_price'].value;
        let upgrades_total = this.EOI_form.controls['upgrades_total'].value;
        let carpark_price = this.EOI_form.controls['carpark_price'].value;
        this.otherUpgrade.other_upgrade_price = value;
        this.EOI_form.patchValue({
          total_price: contract_price + carpark_price + storage_price + upgrades_total + value,
        });
      } else {
        let contract_price = this.EOI_form.controls['contract_price'].value;
        let storage_price = this.EOI_form.controls['storage_price'].value;
        let upgrades_total = this.EOI_form.controls['upgrades_total'].value;
        let carpark_price = this.EOI_form.controls['carpark_price'].value;

        this.EOI_form.patchValue({
          total_price: contract_price + carpark_price + storage_price + upgrades_total,
        });
      }
    }
  }

  isOtherUpgrade: boolean = false;
  otherUpgrade = {
    other_upgrade_group: null,
    other_upgrade_type: null,
    other_upgrade_price: 0,
  };

  showOther() {
    this.isOtherUpgrade = !this.isOtherUpgrade;
    this.otherUpgrade = {
      other_upgrade_group: null,
      other_upgrade_type: null,
      other_upgrade_price: null,
    };
  }

  checkValue(eoi) {
    let field_type = typeof eoi?.carpark_number == 'string' && eoi?.carpark_number !== '' ? eoi?.carpark_number : 'Select';
    return field_type;
  }

  saveEOI(method) {
    if (this.isCreateNew) {
      let form_data = this.EOI_form.value;
      form_data['status_code'] = 'Active';
      form_data['office_id'] = this.Api.getOfficeId();
      form_data['user_id'] = this.Api.getUserId();
      form_data['upgrades'] = this.upgrades;
      form_data['bonuses'] = this.bonuses;
      // Save the form data
      this._projectService.saveExpressionOfInterest(form_data).subscribe({
        next: _ => {
          // Show a success message
          this.toast.success('Saved successfully');
          if (method == 'create') {
            this.EOI_form.reset();
            let tab = this.lmService.tab_levels.find(el => el?.name?.toLowerCase()?.includes('eoi'));
            if (tab) {
              let ind = this.lmService.tab_levels.indexOf(tab);
              this.isEOIClosed.emit({ level: tab, index: ind });
            }
          }
        },
        error: error => {
          this.toast.error(error.message);
        },
      });
    } else {
      /**
       * Save the EOI form data to the server
       * @param method "create" or "update"
       */
      let form_data = this.EOI_form.value;
      form_data['upgrades'] = this.upgrades;
      form_data['bonuses'] = this.bonuses;
      form_data['other_upgrade'] = this.otherUpgrade;

      // If the selected unit id is not empty, do bulk update
      if (this.selected_unit_id?.length > 0) {
        // Create a new object with only the changed fields
        let form = {
          record: Object.fromEntries(
            Object.entries(form_data).filter(
              ([key, value]) =>
                value != 0 &&
                value != null &&
                value !== '' &&
                value != 0 &&
                value != null &&
                key !== '' &&
                key !== 'preference_tag' &&
                key !== 'is_read'
            )
          ),
          office_id: this.Api.getOfficeId(),
          selected_records: this.selected_unit_id,
          module: 'expression_of_interest',
        };
        // Call the API
        this._projectService.bulkEditEoi(form).subscribe({
          next: async () => {
            // Show a success message
            this.toast.success('Update successfully');
            // If it's a create, reset the form and close the tab
            if (method == 'create') {
              this.EOI_form.reset();
              this.isEOIEdit = false;
              let tab = this.lmService.tab_levels.find(el => el?.name?.toLowerCase()?.includes('eoi'));
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.isEOIClosed.emit({ level: tab, index: ind });
              }
            } else {
              this.loadData();
            }
          },
          error: error => {
            this.toast.error(error?.error?.message ? error?.error?.message : error?.message);
          },
        });
      } else {
        // If the selected unit id is empty, do a single update
        let carpark_included_value = this.EOI_form.controls['carpark_included'].value;
        let carpark_added_value = this.EOI_form.controls['carpark_added'].value;
        let storage_included_value = this.EOI_form.controls['storage_included'].value;
        let storage_added_value = this.EOI_form.controls['storage_added'].value;

        let car_park_included =
          carpark_included_value?.length > 0
            ? carpark_included_value?.map(ele => {
                ele = { carpark_lot: ele, type: 'included' };
                return ele;
              })
            : [];
        let car_park_Added =
          carpark_added_value?.length > 0
            ? carpark_added_value?.map(ele => {
                ele = { carpark_lot: ele, type: 'added' };
                return ele;
              })
            : [];
        let storage_included =
          storage_included_value?.length > 0
            ? storage_included_value?.map(ele => {
                ele = { storage_no: ele, type: 'included' };
                return ele;
              })
            : [];
        let storage_Added =
          storage_added_value?.length > 0
            ? storage_added_value?.map(ele => {
                ele = { storage_no: ele, type: 'added' };
                return ele;
              })
            : [];

        const purchaser_list_formatted = this.purchaser_list.map(item => ({
          ...item,
          purchaser: typeof item.purchaser === 'object' && item.purchaser !== null ? item.purchaser._id : item.purchaser,
        }));

        form_data['assigne'] = this.price_term ? this.price_term : false;
        form_data['purchaser_list'] = purchaser_list_formatted?.length > 0 ? purchaser_list_formatted : [];
        form_data['status_code'] = this.EOI_form.controls['status_reason'].value;
        form_data['status_reason_2'] = this.EOI_form.controls['status_reason'].value;
        form_data['carpark_number'] = [...car_park_included, ...car_park_Added];
        form_data['carpark_storage'] = [...storage_included, ...storage_Added];
        form_data['office_id'] = this.Api.getOfficeId();
        form_data['user_id'] = this.Api.getUserId();
        delete form_data['carpark_included'];
        delete form_data['carpark_added'];
        delete form_data['storage_included'];
        delete form_data['storage_added'];
        // Call the API
        let id = this.selected_EOI?._id;

        if (form_data['status_reason'] == 'Cancelled' || form_data['cancelled_date']) {
          form_data['carpark_number'] = [];
          form_data['carpark_price'] = 0;
          form_data['carpark_storage'] = [];
          form_data['storage_price'] = 0;
        }

        console.log('form_data >>:', form_data);

        this._projectService.updateExpressionOfInterest(id, form_data).subscribe({
          next: _ => {
            // Show a success message
            this.toast.success('Update successfully');
            // If it's a create, reset the form and close the tab

            this.lmService.updateProjectSummary(true);

            if (method == 'create') {
              this.EOI_form.reset();
              this.isEOIEdit = false;
              let tab = this.lmService.tab_levels.find(el => el?.name?.toLowerCase()?.includes('eoi'));
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.isEOIClosed.emit({ level: tab, index: ind });
              }
            } else {
              this.loadData();
            }
          },
          error: error => {
            this.toast.error(error?.error?.message ? error?.error?.message : error?.message);
          },
        });
      }
    }
  }

  loadData = () => {
    this._projectService.getExpressionOfInterestById(this.selected_eoi?._id, true).subscribe({
      next: response => {
        this.selected_eoi = response.data;
        this.selected_EOI = response.data;
      },
    });
  };

  closeEOI() {
    /**
     * Reset the EOI form and close the current tab
     */
    this.EOI_form.reset();
    // Get the list of tabs in reverse order
    let tabs = [...this.lmService.tab_levels].reverse();
    // Find the tab with the name 'eoi' and get its index
    let tab = tabs.find(el => el?.name?.toLowerCase()?.includes('eoi'));
    if (tab) {
      let ind = this.lmService.tab_levels.indexOf(tab);
      // Emit the event to close the tab
      this.isEOIClosed.emit({ level: tab, index: ind });
    }
  }

  openRightModal(event: any = '') {
    console.log('event :>> ', event);
    this.lmService.contact_show_div = 'add_contact';
    this.lmService.addTabInLevels('Contact', 'new', null, {}, 'contact');
  }

  getTeamUser(isAll: boolean = false) {
    console.log('team:', this.internal_team);
    if (isAll) {
      if (this.internal_team?.length) {
        const requests = this.internal_team.map(ele => this._userService.getTeamById(ele?._id, '?include=users'));

        forkJoin(requests).subscribe(responses => {
          const internalAgent = responses.flatMap(
            response =>
              response?.data?.user_members?.map(user => ({
                ...user,
                full_name: user?.full_name || user?.name,
              })) || []
          );

          const mergedAgents = this.getUniqueUsers([...this.internal_agent, ...internalAgent]);

          // common assignments
          this.internal_agent = mergedAgents;
          this.association_internal_agent = mergedAgents;

          // only retail case extra assignment
          if (this.selected_EOI?.sale_type === 'retail') {
            this.agency_contact = mergedAgents;
            this.agencyContactLoaded = true;
          }

          console.log('this.association_internal_agent:', this.association_internal_agent);
          this.internalAgentsLoaded = true;
          this.syncAgencySelections();
        });
      } else {
        this.internalAgentsLoaded = true;
        this.syncAgencySelections();
      }
    } else {
      let team = this.EOI_form.controls['internal_team'].value;
      if (team) {
        this._userService.getTeamById(team, '?include=users').subscribe({
          next: response => {
            let team_member = response?.data?.user_members?.map(user => {
              user = { ...user, name: user?.full_name };
              return user;
            });
            const mergedAgents = this.getUniqueUsers([...this.internal_agent, ...team_member]);
            this.internal_agent = mergedAgents;
            this.internalAgentsLoaded = true;
            this.syncAgencySelections();
          },
        });
      } else {
        this.internal_agent = this.association_internal_agent;
        this.internalAgentsLoaded = true;
        this.syncAgencySelections();
      }
    }
  }

  /**
   * Remove duplicate users and normalize name field
   */
  private getUniqueUsers(users: any[]) {
    const uniqueMap = new Map();

    return users
      .filter(user => {
        if (!uniqueMap.has(user._id)) {
          uniqueMap.set(user._id, true);
          return true;
        }
        return false;
      })
      .map(user => ({
        ...user,
        name: user?.full_name || user?.name,
      }))
      ?.sort((a, b) => a?.name.localeCompare(b?.name));
  }

  agency_contact: any[] = [];
  solicitor_contact: any[] = [];
  solicitorContact() {
    /**
     * This function is used to populate the contact lists for the agency and solicitor fields
     * It takes the selected agency and solicitor company ids and makes an API call to get all the contacts
     * for those companies and then filters the results to only include contacts with the type 'agent'
     */

    let agency = this.EOI_form.controls['agency'].value;
    if (agency) {
      this._userService
        .getContactCompanies({
          companyId: [this.EOI_form.controls['agency'].value],
        })
        .subscribe(rex => {
          // Reset the agency contact list
          this.agency_contact = [];
          // Filter the results to only include contacts with the type 'agent'
          this.agency_contact = rex?.data?.sort((a, b) => a?.full_name.localeCompare(b?.full_name)); //?.filter(el => el?.contact_type?.toLowerCase() === 'agent');
          this.agencyContactLoaded = true;
          this.syncAgencySelections();
        });
    } else {
      this.selected_EOI['sale_type'] == 'retail'
        ? (this.agency_contact = this.internal_agent?.map(ele => ({ ...ele, full_name: ele?.full_name || ele?.name })))
        : (this.agency_contact = []);
      this.agencyContactLoaded = true;
      this.syncAgencySelections();
    }
    // Do the same for the solicitor field
    this.loadSolicitorContacts();
  }

  /**
   * The Firm control stores the firm's name, not its id, so the id is looked up in `agencyList`.
   * On edit the record usually patches the form before `/contacts/list` has answered — the lookup
   * then found nothing, the contacts call went out with no company and the Solicitor Name list
   * stayed empty. So this waits for the firm list (`getAgencyList` calls it again once loaded)
   * instead of firing blind.
   *
   * Saved records (e.g. synced from Dynamics) can hold the name with different case or spacing than
   * the contact, so an exact `==` missed, the call went out with `companyId: []` and the list came
   * back empty on edit while picking the firm from the dropdown worked. Names are matched loosely
   * and the controls snapped to the contact's exact name so ng-select marks them selected.
   */
  private loadSolicitorContacts(): void {
    let firm = this.EOI_form.controls['firm'].value;
    if (!firm || !this.agencyList?.length) {
      return;
    }
    const isExist = this.agencyList.find(ele => this.isSameName(ele?.full_name, firm));
    if (!isExist) {
      this.solicitor_contact = [];
      return;
    }
    if (isExist.full_name !== firm) {
      firm = isExist.full_name;
      this.EOI_form.controls['firm'].setValue(firm, { emitEvent: false });
    }
    this._userService
      .getContactCompanies({
        companyId: [isExist._id],
      })
      .subscribe(rex => {
        // A quicker firm change can land its own list first — don't let this older answer overwrite it.
        if (this.EOI_form.controls['firm'].value !== firm) {
          return;
        }
        this.solicitor_contact = (rex?.data ?? []).sort((a, b) => (a?.full_name || '').localeCompare(b?.full_name || ''));
        const solicitor = this.EOI_form.controls['solicitor_name'].value;
        const match = solicitor && this.solicitor_contact.find(ele => this.isSameName(ele?.full_name, solicitor));
        if (match && match.full_name !== solicitor) {
          this.EOI_form.controls['solicitor_name'].setValue(match.full_name, { emitEvent: false });
        }
      });
  }

  /** Case- and whitespace-insensitive name comparison for the name-keyed Firm / Solicitor controls. */
  private isSameName(a: string, b: string): boolean {
    const normalize = (v: string) => (v ?? '').toString().trim().replace(/\s+/g, ' ').toLowerCase();
    return !!a && !!b && normalize(a) === normalize(b);
  }

  clearCarParkStorage(item, method) {
    console.log('value >>:', item, 'Param >>:', method);
    if (method == 'carpark_included') {
      let car_park = this.EOI_form.controls['carpark_included'].value;
      this.EOI_form.patchValue({
        carpark_included: car_park?.filter(ele => ele !== item),
      });
      this.changeCarStorage(null, 'car_park_include');
    } else if (method == 'carpark_added') {
      let car_park = this.EOI_form.controls['carpark_added'].value;
      this.EOI_form.patchValue({
        carpark_added: car_park?.filter(ele => ele !== item),
      });
      this.changeCarStorage(car_park, 'car_park');
    } else if (method == 'storage_included') {
      let car_park = this.EOI_form.controls['storage_included'].value;
      this.EOI_form.patchValue({
        storage_included: car_park?.filter(ele => ele !== item),
      });
      this.changeCarStorage(null, 'storage_include');
    } else if (method == 'storage_added') {
      let storage = this.EOI_form.controls['storage_added'].value;
      this.EOI_form.patchValue({
        storage_added: storage?.filter(ele => ele !== item),
      });
      this.changeCarStorage(storage, 'storage');
    }
  }

  changeCarStorage(_eve, method) {
    /**
     * Updates the unit form based on the event and the method.
     * The methods are:
     * - 'car_park': updates the car park price
     * - 'storage': updates the storage price
     * @param eve the event
     * @param method the method to use
     */

    if (method == 'car_park') {
      let selected = this.EOI_form.controls['carpark_added'].value;
      const result = this.copy_carpark_list.filter(
        car => selected.some(str => str === car.carpark_lot) // strict equality check
      );

      var total = 0;
      result?.forEach(ele => {
        ele?.price ? (total += Number(ele?.price)) : (total = +0);
      });
      // Update the car park price

      let contract_price = this.EOI_form.controls['contract_price'].value ? this.EOI_form.controls['contract_price'].value : 0;
      let storage_price = this.EOI_form.controls['storage_price'].value ? this.EOI_form.controls['storage_price'].value : 0;
      let upgrades_total = this.EOI_form.controls['upgrades_total'].value ? this.EOI_form.controls['upgrades_total'].value : 0;

      this.EOI_form.patchValue({
        carpark_price: total,
        subtotal: contract_price + total + storage_price + upgrades_total,
        total_price: contract_price + total + storage_price + upgrades_total,
      });
    } else if (method == 'storage') {
      // Update the storage price
      let selected = this.EOI_form.controls['storage_added'].value;
      const result = this.copy_storage_list.filter(
        car => selected.some(str => str === car.storage_no) // strict equality check
      );
      // console.log('storage >>:', result);
      var total = 0;
      result?.forEach(ele => {
        ele?.price ? (total += Number(ele?.price)) : (total = +0);
      });
      // Update the car park price

      let contract_price = this.EOI_form.controls['contract_price'].value ? this.EOI_form.controls['contract_price'].value : 0;
      let carpark_price = this.EOI_form.controls['carpark_price'].value ? this.EOI_form.controls['carpark_price'].value : 0;
      let upgrades_total = this.EOI_form.controls['upgrades_total'].value ? this.EOI_form.controls['upgrades_total'].value : 0;

      this.EOI_form.patchValue({
        storage_price: total,
        subtotal: contract_price + total + carpark_price + upgrades_total,
        total_price: contract_price + total + carpark_price + upgrades_total,
      });
    }

    let c_include = this.EOI_form.controls['carpark_included'].value ? this.EOI_form.controls['carpark_included'].value?.length : 0;
    let c_added = this.EOI_form.controls['carpark_added'].value ? this.EOI_form.controls['carpark_added'].value?.length : 0;
    let s_include = this.EOI_form.controls['storage_included'].value ? this.EOI_form.controls['storage_included'].value?.length : 0;
    let s_added = this.EOI_form.controls['storage_added'].value ? this.EOI_form.controls['storage_added'].value?.length : 0;

    this.EOI_form.patchValue({
      space: c_include + c_added,
      storage: s_include + s_added,
    });
  }

  status_reason: any[] = [];
  not_further_interest: any[] = [];

  getTags() {
    /**
     * This function retrieves the contract status tags from the server
     * and stores them in the component's status_reason property
     */
    this.redux.getTags(this.Api.getOfficeId(), true, 'contract').subscribe(res => {
      // Loop through the response data and find the contract status tags
      res?.data?.forEach(x => {
        x.types?.forEach(y => {
          if (y?.slug == 'contract-status') {
            // Store the contract status tags in the status_reason property
            this.status_reason = [...y?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1));
          }
          if (y?.slug == 'no-further-interest') {
            // Store the contract status tags in the status_reason property
            this.not_further_interest = [...y?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1));
          }
        });
      });
    });

    this.redux.getTags(this.Api.getOfficeId(), true, 'project').subscribe(res => {
      // Loop through the response data and find the contract status tags
      res?.data?.forEach(x => {
        x.types?.forEach(tag => {
          if (tag?.slug == 'non-ypm-sale') {
            this.YpmSales = [...tag?.data].sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
          }
          if (tag?.slug == 'purchase-type') {
            this.purchase_type = [...tag?.data].sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
          }
        });
      });
    });
  }

  getAssociate(bol: boolean = true, id = null) {
    let office_id = this.Api.getOfficeId();
    let uid = this.Api.getUserId();
    let url1 = `/search-data?office_id=${office_id}&user_id=${uid}&Keywords&page=1&limit=999&module=project-associated-contacts&project_id=${id}`;
    let url = `/project-internal-association/${id}`;

    this.redux.getSetProjectInfo(bol, 'internal-' + id, url, ReduxService.BURST_FRESH_MS).subscribe(response => {
      let filter_team = JSON.parse(JSON.stringify(response.data));
      let filter_user = JSON.parse(JSON.stringify(response.data));
      this.association_internal_agent = this.internal_agent = filter_user?.filter(user => user?.is_user == true);
      this.internal_team = filter_team?.filter(user => user?.is_user == false);
    });
    this.redux.getSetProjectInfo(bol, 'external-' + id, url1).subscribe(f => {
      this.externalAgency = JSON.parse(JSON.stringify(f.data))?.sort((a, b) => a?.full_name.localeCompare(b?.full_name));
      this.externalAgencyLoaded = true;
      this.syncAgencySelections();
    });
    this.patchEditForm(this.selected_eoi?._id, true);
  }

  car_park_list: any[] = [];
  copy_carpark_list: any[] = [];
  storage_list: any[] = [];
  copy_storage_list: any[] = [];

  getCarParkStorage(id) {
    /**
     * Retrieves the car park and storage data for the given project ID.
     *
     * @param id The project ID
     */
    this._projectService.getCarParkStorage(id).subscribe(response => {
      // Initialize car park and storage lists
      this.car_park_list = [];
      this.storage_list = [];
      this.copy_carpark_list = [];
      this.copy_storage_list = [];
      this.copy_carpark_list = response?.data[0].data.car_park;
      this.copy_storage_list = response?.data[0].data.storage;
      this.car_park_list = response?.data[0].data.car_park?.filter(car => car?.lot == '' || car?.lot == null);
      this.storage_list = response?.data[0].data.storage?.filter(storage => storage?.lot == '' || storage?.lot == null);
    });
  }

  eoiLeadList: any[] = [];
  total_lead = null;
  getEoiLeadList(page = 1, per_page = 999) {
    // Define columns to fetch from the API
    let cols = ['listing_project', 'full_name', 'email', 'mobile_phone', 'lead_status', 'lead_type', 'agent_responsible', 'created_at'];
    // API request to fetch leads with filtering and pagination
    this.leadsService
      .getAllNewLeads({
        office_id: this.Api.getOfficeId(),
        page: page,
        per_page: per_page,
        lead_eoi: this.eoiLeadId,
        columns: cols,
      })
      .subscribe({
        next: response => {
          this.eoiLeadList = response?.data;
          this.total_lead = response?.meta?.pagination?.total;
        },
      });
  }

  changeGroupPrice(upgrade, index) {
    let total = 0;
    let upgrade_total = 0;

    upgrade.forEach(ele => {
      ele?.cost ? (total += ele?.cost) : (total = 0);
    });
    this.upgrades[index].upgrades_total = total;

    // console.log('total_upgrades >>:', this.upgrades);
    this.upgrades?.forEach(ele => {
      ele?.upgrades_total ? (upgrade_total += ele?.upgrades_total) : (upgrade_total = 0);
    });

    let contract_price = this.EOI_form.controls['contract_price'].value ? this.EOI_form.controls['contract_price'].value : 0;
    let carpark_price = this.EOI_form.controls['carpark_price'].value ? this.EOI_form.controls['carpark_price'].value : 0;
    let storage_price = this.EOI_form.controls['storage_price'].value ? this.EOI_form.controls['storage_price'].value : 0;

    this.EOI_form.patchValue({
      total_price: contract_price + upgrade_total + carpark_price + storage_price,
      upgrades_total: upgrade_total,
    });
  }

  upgradeGroupList: any[] = [null];
  changeGroup(e, i, item) {
    if (item && item?.upgrade_group_1) {
      item.upgrade_group_1 = null;
    }
    this.upgradeGroupList[i] = e?.list;
  }
}
